import { render, staticRenderFns } from "./ModalDeleteAdmin.vue?vue&type=template&id=5bdb4990"
import script from "./ModalDeleteAdmin.vue?vue&type=script&lang=js"
export * from "./ModalDeleteAdmin.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteAdmin.vue?vue&type=style&index=0&id=5bdb4990&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports